import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 24px 16px;
`;

export const Modal = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 620px;
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
  gap: 22px;
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ModalTitle = styled.h2`
  color: #1b3a6b;
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: #888;
  font-size: 1.2rem;
  line-height: 1;
  cursor: pointer;
  padding: 4px;

  &:hover { color: #333; }
`;

export const Columns = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr;
  gap: 24px;

  @media (max-width: 540px) {
    grid-template-columns: 1fr;
  }
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const GroupTitle = styled.h3`
  color: #1b3a6b;
  font-size: 0.9rem;
  font-weight: 700;
  margin: 0;
`;

export const CheckRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  accent-color: #26A9B6;
  cursor: pointer;
  flex-shrink: 0;
`;

export const CheckLabel = styled.label`
  font-size: 0.85rem;
  color: #333;
  cursor: pointer;
`;

export const AgeRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  max-width: 420px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Label = styled.label`
  font-size: 0.82rem;
  font-weight: 600;
  color: #444;
`;

export const Input = styled.input`
  padding: 9px 12px;
  border: 1.5px solid #d0dce8;
  border-radius: 7px;
  font-size: 0.88rem;
  color: #222;
  outline: none;
  background: #fff;

  &:focus { border-color: #26A9B6; }
  &::placeholder { color: #aaa; }
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 4px;
`;

export const RightActions = styled.div`
  display: flex;
  gap: 12px;
`;

export const ResetButton = styled.button`
  padding: 10px 18px;
  border-radius: 8px;
  border: 1.5px solid #d0dce8;
  background: #fff;
  color: #555;
  font-size: 0.85rem;
  cursor: pointer;

  &:hover { background: #f5f5f5; }
`;

export const CancelButton = styled.button`
  padding: 10px 22px;
  border-radius: 8px;
  border: 1.5px solid #d0dce8;
  background: #fff;
  color: #555;
  font-size: 0.88rem;
  cursor: pointer;

  &:hover { background: #f5f5f5; }
`;

export const SubmitButton = styled.button`
  padding: 10px 26px;
  border-radius: 8px;
  border: none;
  background: #1b6b78;
  color: #fff;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #175a65; }
`;
